import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const SaFungerarElmarknaden = lazy(() => import("@/pages/elmarknaden/SaFungerarElmarknaden"));

export const Route = createFileRoute("/elmarknaden/sa-fungerar-elmarknaden")({
  head: () => seoHead("/elmarknaden/sa-fungerar-elmarknaden", { description: "Från kraftverket till ditt eluttag – aktörerna, elbörsen och hur priset för varje timme faktiskt sätts." }),
  component: () => <SaFungerarElmarknaden />,
});
